import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { initFrame } from '@/model/global/actions';

const withFrameDetection = (Component: React.FC) => (props: { [k in string]: unknown }): JSX.Element => {
  const dispatch = useDispatch();
  const [initialized, setInitialized] = useState(false);
  const initializing = useRef<boolean | undefined>();

  useEffect(() => {
    if (!initialized && !initializing.current) {
      initFrame()(dispatch).then(
        () => {
          setInitialized(true);
          initializing.current = false;
        },
        () => {
          setInitialized(true);
          initializing.current = false;
        },
      );
    }
  }, [dispatch, initialized]);

  return initialized ? <Component {...props} /> : <></>;
};

export default withFrameDetection;
